//pdc-ic-
var libstyle = {
  libContainer: 'pdc-ic-libContainer',
  configContainer: 'pdc-ic-configContainer',
  libDoneButton: 'pdc-ic-libDoneButton',
  libBody: 'pdc-ic-libBody',
  iconBox: 'pdc-ic-iconBox',
  configuratorItem: 'pdc-ic-configuratorItem',
  configuratorItemTitle: 'pdc-ic-configuratorItemTitle',
  inlineContainer: 'pdc-ic-inlineContainer',
  icon: 'pdc-ic-icon'
};
export { libstyle };